import { render } from "./userSubscribtion.vue?vue&type=template&id=4a7606f4&scoped=true"
import script from "./userSubscribtion.vue?vue&type=script&lang=js"
export * from "./userSubscribtion.vue?vue&type=script&lang=js"

import "./userSubscribtion.vue?vue&type=style&index=0&id=4a7606f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7606f4"]])

export default __exports__